import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DashboardService {
    private baseURL: string;
    constructor(private http: HttpClient) {
        this.baseURL = environment.apiBaseUrl;;
    }

    getBoothRentalRevenue(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Dashboard/GetBoothRentalRevenue`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getOtherRentalRevenue(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Dashboard/GetOtherRentalRevenue`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getSalesDataForDateRangeByMonth(yearly, hourSales): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Dashboard/GetSalesDataForDateRangeByMonth?yearly=${yearly}&hourSales=${hourSales}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getSalesDataForDateRangeByHour(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/Dashboard/GetSalesDataForDateRangeByHour`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getSalesDataForDateRange(request): Observable<any[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const url = `${this.baseURL}/Dashboard/GetSalesDataForDateRange`;
        return this.http.post<any>(url, request, options)
            .pipe(
                map(res => {
                    const response = res as any[];
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            // this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}